import { Component } from '@angular/core';

@Component({
  selector: 'app-power-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './power-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class PowerIconComponent {}
